<!--轨迹点详细-->
<template>
  <Modal :visible.sync="visible" :title="$t('轨迹点详情')" append-to-body>
    <EquiInfo :detail-info="detailInfo" :extInfo="extInfo"></EquiInfo>
    <ProbeDetail></ProbeDetail>
  </Modal>
</template>

<script>
import { mapTrackTraceDetail } from '@/api/modules/map'
import EquiInfo from '@/pages/home/component/Map/component/equiInfo.vue'
import SensorDetailDialog from '@/components/dialog/sensorDetail/sensorDetailDialog.vue'
import GatewayDetailDialog from '@/components/dialog/gatewayDetail/gatewayDetailDialog.vue'
import ProbeDetail from '@/components/dialog/probeDetail/ProbeDetail.vue'

export default {
  components: {
    ProbeDetail,
    GatewayDetailDialog,
    SensorDetailDialog,
    EquiInfo
  },
  props: {
    // 包含id-监测点id 和 time - 某一时刻
    info: {}
  },
  data () {
    return {
      visible: false,
      detailInfo: {},
      extInfo: null
    }
  },

  methods: {
    open ({ id, time }, extInfo) {
      this.visible = true
      this.extInfo = extInfo

      mapTrackTraceDetail({
        id: id,
        time: time
      }).then(({ result }) => {
        this.detailInfo = { carrier: result.state }
      })
    }
  }
}
</script>
